import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface IComplaintMessageFile {
  [key: string]: any
}

class ComplaintMessageFile extends Model<IComplaintMessageFile> {
  static urlRoot() {
    return '/complaints/message_files'
  }

  constructor(data: IComplaintMessageFile = {}) {
    super(data)

    makeObservable(this, {
      path: computed,
      name: computed,
    })
  }

  get path() {
    return this.attributes.path
  }

  get name() {
    return this.attributes.filename
  }
}

export default ComplaintMessageFile
